import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { __ } from '../../i18n/l10n';
import { COLORS } from '../../styles/colors';
import { WxButton, WxText } from '../index';

export interface WxDialogProps {
  title: string;
  content?: string;
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  setOpen: (bool: boolean) => void;
  noCancel?: boolean;
}

const WxDialog = ({
  title,
  content,
  open,
  onClose,
  setOpen,
  children,
  noCancel = false,
}: WxDialogProps) => {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    open && ref?.current?.showModal();
  }, [open]);

  return (
    <Dialog ref={ref}>
      <div>
        <WxText text={content} title={title} align={'center'} />
        {children}
        <Row>
          {!noCancel && (
            <WxButton
              type={'neutral'}
              onClick={() => {
                ref?.current?.close();
                setOpen(false);
              }}
              label={__('Cancel')}
              noArrow
              expand
            />
          )}
          <WxButton
            type={'validation'}
            onClick={() => {
              setOpen(false);
              ref?.current?.close();
              onClose();
            }}
            label={__('CONFIRM')}
            noArrow
            expand
          />
        </Row>
      </div>
    </Dialog>
  );
};

const Dialog = styled.dialog`
  background-color: ${COLORS.white};
  padding: 1.25rem;

  @media (min-width: 1021px) {
    position: absolute;
    bottom: 50%;
  }

  &::backdrop {
    background-color: hsla(0, 0%, 0%, 0.2);
  }

  > * {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const Row = styled.div`
  padding-top: 1.25rem;
  display: flex;
  width: 80%;
  gap: 0.625rem;
`;

export default WxDialog;
